"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Widget", {
  enumerable: true,
  get: function get() {
    return _Widget["default"];
  }
});
Object.defineProperty(exports, "checkFile", {
  enumerable: true,
  get: function get() {
    return _payoutFromFile.checkFile;
  }
});
Object.defineProperty(exports, "confirmTwoFA", {
  enumerable: true,
  get: function get() {
    return _twofa.confirmTwoFA;
  }
});
Object.defineProperty(exports, "createExchange", {
  enumerable: true,
  get: function get() {
    return _exchange.createExchange;
  }
});
Object.defineProperty(exports, "createInvoice", {
  enumerable: true,
  get: function get() {
    return _invoice.createInvoice;
  }
});
Object.defineProperty(exports, "createPayout", {
  enumerable: true,
  get: function get() {
    return _payout.createPayout;
  }
});
Object.defineProperty(exports, "createPayoutFromFile", {
  enumerable: true,
  get: function get() {
    return _payoutFromFile.createPayoutFromFile;
  }
});
Object.defineProperty(exports, "createShop", {
  enumerable: true,
  get: function get() {
    return _shop.createShop;
  }
});
Object.defineProperty(exports, "createTransfer", {
  enumerable: true,
  get: function get() {
    return _transfer.createTransfer;
  }
});
Object.defineProperty(exports, "createUser", {
  enumerable: true,
  get: function get() {
    return _user.createUser;
  }
});
Object.defineProperty(exports, "getCommission", {
  enumerable: true,
  get: function get() {
    return _commissions.getCommission;
  }
});
Object.defineProperty(exports, "getExchangeAmount", {
  enumerable: true,
  get: function get() {
    return _exchange.getExchangeAmount;
  }
});
Object.defineProperty(exports, "getFileByName", {
  enumerable: true,
  get: function get() {
    return _payoutFromFile.getFileByName;
  }
});
Object.defineProperty(exports, "getShops", {
  enumerable: true,
  get: function get() {
    return _shop.getShops;
  }
});
Object.defineProperty(exports, "getShopsV2", {
  enumerable: true,
  get: function get() {
    return _shop.getShopsV2;
  }
});
Object.defineProperty(exports, "getTransferRecipientShops", {
  enumerable: true,
  get: function get() {
    return _shop.getTransferRecipientShops;
  }
});
Object.defineProperty(exports, "getTwoFATokenData", {
  enumerable: true,
  get: function get() {
    return _twofa.getTwoFATokenData;
  }
});
Object.defineProperty(exports, "getUser", {
  enumerable: true,
  get: function get() {
    return _user.getUser;
  }
});
Object.defineProperty(exports, "name", {
  enumerable: true,
  get: function get() {
    return _slice.name;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _slice.reducer;
  }
});
Object.defineProperty(exports, "refreshTwoFA", {
  enumerable: true,
  get: function get() {
    return _twofa.refreshTwoFA;
  }
});
Object.defineProperty(exports, "resetRegisterAction", {
  enumerable: true,
  get: function get() {
    return _slice.resetRegisterAction;
  }
});
Object.defineProperty(exports, "resetStateAction", {
  enumerable: true,
  get: function get() {
    return _slice.resetStateAction;
  }
});
Object.defineProperty(exports, "selectExchangeAmount", {
  enumerable: true,
  get: function get() {
    return _slice.selectExchangeAmount;
  }
});
Object.defineProperty(exports, "selectFile", {
  enumerable: true,
  get: function get() {
    return _slice.selectFile;
  }
});
Object.defineProperty(exports, "selectInProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectInProcess;
  }
});
Object.defineProperty(exports, "selectInSubmitProcess", {
  enumerable: true,
  get: function get() {
    return _slice.selectInSubmitProcess;
  }
});
Object.defineProperty(exports, "selectShops", {
  enumerable: true,
  get: function get() {
    return _slice.selectShops;
  }
});
Object.defineProperty(exports, "selectToken", {
  enumerable: true,
  get: function get() {
    return _slice.selectToken;
  }
});
Object.defineProperty(exports, "selectTransferRecipientShops", {
  enumerable: true,
  get: function get() {
    return _slice.selectTransferRecipientShops;
  }
});
Object.defineProperty(exports, "setInProcessAction", {
  enumerable: true,
  get: function get() {
    return _slice.setInProcessAction;
  }
});
Object.defineProperty(exports, "updateUser", {
  enumerable: true,
  get: function get() {
    return _user.updateUser;
  }
});

var _Widget = _interopRequireDefault(require("./Widget"));

var _slice = require("./ducks/slice");

var _payout = require("./ducks/commands/payout");

var _invoice = require("./ducks/commands/invoice");

var _transfer = require("./ducks/commands/transfer");

var _commissions = require("./ducks/commands/commissions");

var _exchange = require("./ducks/commands/exchange");

var _twofa = require("./ducks/commands/twofa");

var _user = require("./ducks/commands/user");

var _payoutFromFile = require("./ducks/commands/payout-from-file");

var _shop = require("./ducks/commands/shop");